import { Navigate, useLocation } from 'react-router';

const RedirectTo404 = () => {
  const location = useLocation();

  return (
    <Navigate
      replace
      state={{ from: location }}
      to="/404"
    />
  );
};

export default RedirectTo404;
